import * as styles from "./TaxInfoNote.module.scss";
import {
    popup,
    ButtonResult,
    ButtonType,
} from "ui";

type TaxInfoNoteProps = {
    iconOnly?: boolean
}

const taxInfoForAnonymousUsers = (window as any).app.preloadState.taxInfoForAnonymousUsers;
const translations = window.app.preloadState.translation;
const isLoggedIn = (window as any).app.preloadState.isLoggedIn;

export const TaxInfoNote = ({ iconOnly = false }: TaxInfoNoteProps) => {

    if (isLoggedIn) {
        return;
    }

    const showDeliveryInfoPopUp = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        popup(
            taxInfoForAnonymousUsers.title,
            taxInfoForAnonymousUsers.description,
            [
                { label: translations["taxInfo.button"], result: ButtonResult.Cancel, type: ButtonType.Primary }
            ]
        );
    }

    return <>
        {iconOnly ?
            <span className={ styles.infoIcon} onClick={(e) => { showDeliveryInfoPopUp(e) }}></span>
            :
            <span className={styles.taxInfoSpan}>{taxInfoForAnonymousUsers.taxInfoStringStaticPart} <span className={styles.anchorLikeStyling} onClick={(e) => { showDeliveryInfoPopUp(e) }}>{translations["taxInfo.taxInfoPopUp"]}</span></span>
        }
    </>
}
